import { render, staticRenderFns } from "./SuccessCase.vue?vue&type=template&id=5ca8a608&scoped=true&"
import script from "./SuccessCase.vue?vue&type=script&lang=js&"
export * from "./SuccessCase.vue?vue&type=script&lang=js&"
import style0 from "./SuccessCase.vue?vue&type=style&index=0&id=5ca8a608&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca8a608",
  null
  
)

export default component.exports